import {
  CHANGE_SEARCH,
  UPDATE_REALTY_OFFERS_SECONDARY,
  UPDATE_INPUT_INTERVALS_SECONDARY_GENERAL,
  CLEAR_FILTERS_SECONDARY,
  SET_LAUNCHING_YEARS_SECONDARY,
  UPDATE_REQUEST_STATUS_SECONDARY,
  UPDATE_PAYLOAD_REQUEST,
  CLOSE_INFOWINDOWS_SECONDARY,
  SET_INFOWINDOWS_SECONDARY,
  UPDATE_BUILDING_DATA_SECONDARY,
  UPDATE_CHARTS_DATA_SECONDARY,
  STORE_CHART_DATA,
  CLEAR_STORAGED_CHART_DATA_SECONDARY,
} from './offersSecondary.actions';

// TODO: Add commercial realtyType

const realtyOffersFiltersOptions = {
  launchingYears: [],
  constructionPattern: [],
  adTypes: [
    { name: 'Venda', id: 'sale' },
    { name: 'Locação', id: 'rent' },
  ],
  realtyTypes: [
    { name: 'Apartamento', id: 'ap' },
    { name: 'Casa', id: 'cs' },
    // { name: 'Comercial', id: 'comm' },
  ],
  timeframe: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  privateAreaInterval: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  // valueInterval: [
  //   { name: 'min', value: '' },
  //   { name: 'max', value: '' },
  // ],
  bedrooms: [
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  suites: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  garages: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    {
      name: '2',
      selected: false,
    },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  unitPrice: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  status: '',
  buildings: '',
  companies: '',
};

const initialFiltersSecondary = {
  adType: 'sale',
  realtyType: { name: 'Apartamento', id: 'ap' },
  inputIntervals: {
    timeframe: { min: '', max: '' },
    privateAreaInterval: { min: '', max: '' },
    pricePerSquareMt: { min: '', max: '' },
    unitPrice: { min: '', max: '' },
    realtyAge: { min: '', max: '' },
  },
  bedrooms: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  suites: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  garages: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
};

const initialState = {
  realtyOffersFiltersOptions,
  realtyOffersSecondaryGeneral: initialFiltersSecondary,
  displayBigNumbersSecondaryCharts: false,
  displaySecondaryCharts: false,
  newAlertName: '',
  isActive: {
    sidebar: true,
    menuAction: '',
    mapAction: '',
    results: false,
  },
  userInput: {
    building: '',
    company: '',
  },
  payloadRequest: {},
  requestStatusSecondary: {
    // INACTIVE | LOADING | LOADED | FAILED
    realtyAnnouncedByPeriod: 'INACTIVE',
    announcedOverExisting: 'INACTIVE',
    adsPerExistingRealties: 'INACTIVE',
  },
  infoWindowsSecondary: [],
  chartsDataSecondary: {
    price_variation_by_period: [],
    ads_per_existing_realties: [],
    realty_announced_by_period: [],
    average_realty_announced_by_period: [],
    average_realties_announced_over_existing_realties: [],
  },
  secondaryChartData: null,
  buildingData: {},
};

export default function offersSecondaryReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case CHANGE_SEARCH:
      return {
        ...state,
        userInput: { ...state.userInput, [payload.name]: payload.value },
      };

    case UPDATE_REALTY_OFFERS_SECONDARY:
      return {
        ...state,
        realtyOffersSecondaryGeneral: {
          ...state.realtyOffersSecondaryGeneral,
          [payload.name]: payload.value,
        },
      };

    case UPDATE_INPUT_INTERVALS_SECONDARY_GENERAL:
      return {
        ...state,
        realtyOffersSecondaryGeneral: {
          ...state.realtyOffersSecondaryGeneral,
          inputIntervals: {
            ...state.realtyOffersSecondaryGeneral.inputIntervals,
            [payload.name]: payload.value,
          },
        },
      };

    case CLEAR_FILTERS_SECONDARY:
      return {
        ...state,
        realtyOffersSecondaryGeneral: {
          ...initialFiltersSecondary,
          inputIntervals: {
            timeframe: { min: '', max: '' },
            privateAreaInterval: { min: '', max: '' },
            pricePerSquareMt: { min: '', max: '' },
            unitPrice: { min: '', max: '' },
            realtyAge: { min: '', max: '' },
          },
        },
      };

    case SET_LAUNCHING_YEARS_SECONDARY:
      return {
        ...state,
        realtyOffersFiltersOptions: {
          ...state.realtyOffersFiltersOptions,
          launchingYears: payload,
        },
      };

    case UPDATE_REQUEST_STATUS_SECONDARY:
      return {
        ...state,
        requestStatusSecondary: {
          ...state.requestStatusSecondary,
          [payload.name]: payload.value,
        },
      };

    case UPDATE_BUILDING_DATA_SECONDARY:
      return { ...state, buildingData: { ...state.buildingData, ...payload } };
    case UPDATE_PAYLOAD_REQUEST:
      return { ...state, payloadRequest: payload };

    case SET_INFOWINDOWS_SECONDARY:
      return { ...state, infoWindowsSecondary: [payload] };

    case CLOSE_INFOWINDOWS_SECONDARY:
      state.infoWindowsSecondary?.forEach((iw) => iw.close());
      return state;
    case UPDATE_CHARTS_DATA_SECONDARY:
      return {
        ...state,
        chartsDataSecondary: {
          ...state.chartsDataSecondary,
          [payload.name]: payload.value,
        },
      };
    case STORE_CHART_DATA:
      return { ...state, secondaryChartData: payload };
    case CLEAR_STORAGED_CHART_DATA_SECONDARY:
      return {
        ...state,
        secondaryChartData: null,
      };
    default:
      return state;
  }
}
